import styled, { css, keyframes } from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";

export const Overlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: 2;
  padding-top: 10px;

  overflow: hidden;
  transition: opacity 0.4s;

  display: none;
  opacity: 0;
  align-items: center;
  justify-content: center;
`;

export const ContainerSideBar = styled.div`
  position: fixed;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0px;
  z-index: 3;

  display: flex;

  > span {
    margin: 2px 5px;
    padding: 5px;
    height: fit-content;

    background-color: #000c;
    cursor: pointer;
    border-radius: 10px;

    display: flex;
    justify-content: center;
    align-items: center;

    transition: 0.3s;

    box-shadow: 0px 0px 5px white;

    :hover {
      background-color: var(--black);
    }
  }
`;

const rotacionarHorario = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
`;

const rotacionarAnteHorario = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-180deg);
  }
`;

export const StyledFaBars = styled(FaBars)`
  color: var(--white);
  animation: ${(props) =>
    props.animar
      ? css`
          ${rotacionarAnteHorario} .5s ease-out;
        `
      : ""};
`;

export const StyledFaTimes = styled(FaTimes)`
  color: var(--white);
  animation: ${rotacionarHorario} 0.5s ease-out;
`;

export const SideBar = styled.nav`
  width: 0px;
  height: 100vh;
  z-index: 3;

  overflow-x: hidden;
  background-color: var(--white);
  box-shadow: 2px 0px 5px;

  transition: 0.3s;

  display: flex;
  flex-direction: column;

  background: var(--gradientPrimary);
  background: radial-gradient(
    circle at bottom,
    var(--gradientPrimary) 50%,
    var(--gradientSecondary) 150%
  );

  > header {
    > img {
      margin: 30px;
      width: calc(100% - 60px);

      box-sizing: content-box;
    }
    > h1 {
      color: var(--white);
      margin-top: -30px;
      margin-right: 40px;
      text-align: right;
    }
  }

  > ul {
    margin-top: 20px;

    > li {
    }
  }
`;

export const ItemList = styled.li`
  margin: 10px;
  padding: 10px;
  color: var(--white);
  border-radius: 6px;

  cursor: pointer;
  white-space: nowrap;
  transition: 0.4s;

  display: flex;
  align-items: center;

  > svg {
    margin-right: 10px;
  }
  font-weight: ${(props) => (props.active ? "bold" : "none")};

  background-color: ${(props) => (props.active ? "var(--white);" : "none")};
  color: ${(props) => (props.active ? "var(--black);" : "none")};

  :hover {
    font-weight: bold;

    background-color: var(--white);
    color: var(--black);
  }
`;

export const Icon = styled.img`
  width: 20px;
`;
